import { PerformRequest } from "../lib/usePerformRequest";
import { Endpoints } from "../lib/endpoints";
import { PaginatedResponse, NonPaginatedResponse } from "../lib/types";

export interface ITestimonialProps {
  id: string;
  name: string;
  text: string;
  status: "pending" | "approved" | "rejected";
  createdAt: number;
  updatedAt?: number;
}

export async function getTestimonials(
  page: number = 1,
  limit: number = 10,
  status?: string
): Promise<PaginatedResponse<ITestimonialProps[]>> {
  const result = await PerformRequest<PaginatedResponse<ITestimonialProps[]>>({
    method: Endpoints.GetTestimonialsList(page, limit, status).method as any,
    route: Endpoints.GetTestimonialsList(page, limit, status).route,
  });

  if (result.status === 200) {
    return result.data;
  }

  throw new Error(result.message || "Failed to fetch testimonials");
}

export async function updateTestimonialStatus(
  id: string,
  status: "pending" | "approved" | "rejected"
): Promise<ITestimonialProps> {
  const result = await PerformRequest<NonPaginatedResponse<ITestimonialProps>>({
    method: Endpoints.UpdateTestimonialStatus(id).method as any,
    route: Endpoints.UpdateTestimonialStatus(id).route,
    data: { status },
  });

  if (result.status === 200) {
    return result.data.data;
  }

  throw new Error(result.message || "Failed to update testimonial status");
}

export async function deleteTestimonial(id: string): Promise<void> {
  const result = await PerformRequest<NonPaginatedResponse<void>>({
    method: Endpoints.DeleteTestimonial(id).method as any,
    route: Endpoints.DeleteTestimonial(id).route,
  });

  if (result.status !== 200) {
    throw new Error(result.message || "Failed to delete testimonial");
  }
}

